import React from "react";
import "./tenantonboard.css";
import { FORM_CONTROLFIELD_TYPES } from "../../../constants/constants";
import { OnboardingBasicDetailsForm, OnboardingForms, } from "../../../typings/onboarding";
import { DocumentEntityTypesEnum, DocumentTypesEnum, LoginService } from "@propertelligent/client-api";
import CustomInputs from "../../common/Inputs";
import { checkEmptyFieldsFunc, validateEmail, validateFirstName, validateLastName, validateNumber, validatePassword } from "../../../utils/validateHelper";
import { useError } from "../../../utils/context/ErrorContext";
import SimpleButton from "../../../newComponents/buttons/Simple-button";
import { GetImages } from "../../../utils/GetImages";
import BulletPointIcon from "../../../assets/svgs/bulletPointIcon"
import apiHelper from "../../../utils/apiHelper";
import { loginResponseHandler } from "../../../services/login.service";
import { TextCss } from "../../GlobalCss/TextCss";

const StepOne: React.FC<any> = ({
  formData,
  setFormData,
  docsArr,
  setDocsArr,
  isEdit,
  leaseApplicationid,
  leaseApplicationToken,
  fetchData,
  tenantId
  // handleSubmit
}: {
  formData: OnboardingBasicDetailsForm;
  setFormData: React.Dispatch<React.SetStateAction<OnboardingForms>>;
  docsArr: any;
  setDocsArr: any;
  isEdit: boolean,
  leaseApplicationid: number,
  leaseApplicationToken: string,
  fetchData: () => void,
  tenantId: any
  // handleSubmit:(e: React.FormEvent<HTMLFormElement>) => void;
}) => {
  const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } = useError()
  const handleChange = (key: string, value: string) => {
    setFormData((prevFormsData) => ({
      ...prevFormsData,
      BasicDetails: { ...prevFormsData.BasicDetails, [key]: value },
    }));
    const errorKey = `${key}`;
    setErrors((prevErrors) => ({ ...prevErrors, [errorKey]: false }));
    setErrorMessages((prevMessages) => ({ ...prevMessages, [errorKey]: "" }));
  };

  const handleUploadServiceRequestDocument = async (selectedFile) => {
    if (!selectedFile || !["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(selectedFile.type)) {
      setErrors({ ...errors, FileType: true })
      return;
    }
    const maxSize = 1 * 1024 * 1024;
    if (selectedFile.size > maxSize) {
      setErrors({ ...errors, FileType: false, FileSize: true })
      return;
    }

    setErrors({ ...errors, FileType: false, FileSize: false })

    if (selectedFile) {
      const newDoc = {
        EntityTypeId: DocumentEntityTypesEnum.Tenant,
        EntityId: tenantId,
        documentTypeId: DocumentTypesEnum.Identification,
        IsMain: false,
        fileName: selectedFile?.name,
        Document: new Blob([selectedFile]),
        _rawFile: selectedFile,
      };
      setDocsArr((prevState) => [...prevState, newDoc]);
    }
  };

  const BasicDetails = [
     {
      id: 1,
      name: "name",
      labelText: "First Name",
      type: FORM_CONTROLFIELD_TYPES.TEXT,
      value: formData?.firstName,
      isFormControl: true,
      onBlur: () => validateFirstName(formData.firstName, setErrors, setErrorMessages),
      onChange: (e) => { handleChange("firstName", e.target.value) },
      placeholder: "Enter first name",
      myClassName: "containerTextField",
      isError: errors?.firstName,
      disabled:true,
      errorMessages: errorMessages?.firstName,
    },
    {
      id: 2,
      name: "lastName",
      labelText: "Last Name",
      type: FORM_CONTROLFIELD_TYPES.TEXT,
      value: formData?.lastName,
      isFormControl: true,
      onBlur: () => validateLastName(formData.lastName, setErrors, setErrorMessages),
      onChange: (e) => handleChange("lastName", e.target.value),
      placeholder: "Enter last name",
      myClassName: "containerTextField",
      isError: errors?.lastName,
      disabled:true,
      errorMessages: errorMessages?.lastName,
    },
    {
      id: 3,
      name: "email",
      labelText: "Email",
      type: FORM_CONTROLFIELD_TYPES.EMAIL,
      value: formData?.email,
      isFormControl: true,
      onBlur: () => validateEmail(formData?.email, setErrors, setErrorMessages),
      onChange: (e) => handleChange("email", e.target.value),
      placeholder: "Enter email",
      myClassName: "containerTextField",
      isError: errors?.email,
      disabled:true,
      errorMessages: errorMessages?.email,
    },
    {
      id: 4,
      name: "phoneNumber",
      labelText: "Phone",
      type: FORM_CONTROLFIELD_TYPES.MOBILE,
      value: formData?.phoneNumber,
      isFormControl: true,
      onChange: (e) => handleChange("phoneNumber", e.target.value),
      placeholder: "Enter phone number",
      myClassName: "containerTextField",
      isError: errors?.phoneNumber,
      errorMessages: errorMessages?.phoneNumber,
      disabled:true,
      maxLength: 10,
    },
    {
      id: 5,
      name: "password",
      labelText: "Password",
      type: FORM_CONTROLFIELD_TYPES.PASSWORD,
      value: formData?.password,
      isFormControl: true,
      onBlur: () => validatePassword(formData?.password, setErrors, setErrorMessages),
      onChange: (e) => handleChange("password", e.target.value),
      placeholder: "Enter Password",
      myClassName: "containerTextField",
      isError: errors?.password,
      errorMessages: errorMessages?.password,
      isPassword: isEdit ? false : true,
      disabled: isEdit,

    },
    {
      id: 6,
      name: "confirmPassword",
      labelText: "Confirm Password",
      type: FORM_CONTROLFIELD_TYPES.PASSWORD,
      value: formData?.confirmPassword,
      isFormControl: true,
      onBlur: () => {
        if (formData?.password !== formData?.confirmPassword) {
          setErrors(prev => ({ ...prev, confirmPassword: true }))
          setErrorMessages(prev => ({
            ...prev,
            confirmPassword: "Confirm password must match password",
          }))
        } else {
          setErrors({ ...errors, confirmPassword: false })
          setErrorMessages({ ...errorMessages, confirmPassword: "" })
        }
      },
      onChange: (e) => handleChange("confirmPassword", e.target.value),
      placeholder: "Enter confirm Password",
      myClassName: "containerTextField",
      isError: errors?.confirmPassword,
      errorMessages: errorMessages?.confirmPassword,
      isPassword: isEdit ? false : true,
      disabled: isEdit,

    }
  ]

  const documents = [
    'Lease Application Document',
    'Lease Application Document',
    'Lease Application Document',
  ];

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (checkEmptyFieldsFunc(formData, clearErrors, errors, errorMessages, setErrors, setErrorMessages,)) { return }
    const isPasswordInvalid = validatePassword(
      formData.password,
      setErrors,
      setErrorMessages
    );

    // THEN confirm password check
    if (formData.password !== formData.confirmPassword) {
      setErrors(prev => ({
        ...prev,
        confirmPassword: true,
      }));
      setErrorMessages(prev => ({
        ...prev,
        confirmPassword: "Confirm password must match password",
      }));
      return;
    }

    if (isPasswordInvalid) {
      return;
    }

    await apiHelper(LoginService.postApiLoginAcceptLeaseApplicationInvite, {
      showNotification: true, successMessage: `Password Added succussefully`,
      failureMessage: `Password Unable to Add`
    }, leaseApplicationToken, formData as any)
      .then(async (res) => {
        if (res?.data?.success) {
          const newUrl = window.location.origin + window.location.pathname;
          window.history.replaceState(null, "", newUrl);
          loginResponseHandler(res);
          fetchData()
          const newLeaseApplicationId = res?.data?.success?.tenantInfo?.leaseApplicationId;
          // setLeaseApplicationId(newLeaseApplicationId);

          // Upload documents only after we have the leaseApplicationId
          // if (docsArr.length > 0 && newLeaseApplicationId) {
          //   const newdoc = docsArr.map((doc) => ({
          //     ...doc,
          //     EntityId: newLeaseApplicationId,
          //   }))
          //   await uploadAllImages(newdoc);
          // }

          // getTenantsData()
          // goNextStep();
        }
        return res;
      }).catch((err) => { err.body; })

  }

  return (
    <>
      <div className="basicDetails"
      // id="basicDetailStep"
      >
        <div className="basicDetailContent">
          <div className="welcome-message">
            <div className="iconstyle65 BackgroundlightBlue CommonRoundBackgroundNoSize">
              <img alt="basicdeatils-doc" className="color-white-icon" src={GetImages.emptyStateUsers} />
            </div>
            <p className={TextCss.black.main_heading_700_20}>Welcome, {`${formData?.firstName} ${formData?.lastName}`}</p>
            <p className={TextCss.black.sub_Heading_400_16}>Set your password and start your application</p>
          </div>
          <form onSubmit={handleSubmit} className=" basicDetail-form ">
            <div className="basicDetail_inputSection ">
              {BasicDetails?.map((item) => (
                <CustomInputs
                  key={item.id}
                  name={item.name}
                  type={item.type}
                  value={item.value}
                  labelText={item.labelText}
                  required
                  isFormControl
                  onChange={item.onChange}
                  onBlur={item?.onBlur}
                  disabled={item?.disabled}
                  placeholder={item.placeholder}
                  myClassName={item.myClassName}
                  isError={item.isError}
                  errorMessages={item.errorMessages}
                  isPassword={item?.isPassword}
                  width="100%"
                />

              ))}
            </div>
            <div className="documents">
              <div className="FlexRow gap-2">
                <div className="iconstyle24 BackgroundWhite CommonRoundBackgroundNoSize">
                  <img alt="basicdeatils-doc" className="color-white-icon" src={GetImages.InfoIcon} />
                </div>
                <p className={TextCss.black.sub_heading_600_14}> Keep the Below Documents Handy Before Getting Started </p></div>
              <ul className="mt-2 d-flex flex-column  docMain">
                {documents?.map((doc, index) => (
                  <li className={TextCss.sub_text_400_12} key={index}>
                    <span className="pe-2"> <BulletPointIcon /></span>
                    {doc}</li>
                ))}
              </ul>
            </div>

            {/* Get Started Button */}
            <SimpleButton type="submit" label={"Get Started"} />
          </form>
        </div>
      </div>
    </>
  );
};

export default StepOne;
